import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-delegate-explanation',
    templateUrl: './delegate-explanation.component.html',
    styleUrls: ['./delegate-explanation.component.scss'],
    standalone: false
})
export class DelegateExplanationComponent implements OnInit {
  @Input() public explanation;
  @Input() public addCloseBtn;

  @Output() public closeBtn = new EventEmitter<boolean>();

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

  closeExplanation() {
    this.closeBtn.emit(true);
  }



}
